import NavBar from './NavBar';
import OptionBar from './OptionBar';

const Header = () => (
  <div className="header">
    <OptionBar />
    <NavBar />
  </div>
);

export default Header;
